// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b49159f3","239":"aa88639b","455":"4ca9dd2c"}[chunkId] + ".chunk.js";
};